module.exports = __webpack_public_path__ + "static/img/logo Lotus.936f383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo Lotus.png
// module id = OaNg
// module chunks = 3